import slice from "./frequentlyAskedQuestionsSlice";

export default slice.reducer;
